import React, { useEffect, useMemo, useRef } from "react";
// import dynamic from "next/dynamic";

import { FlexCenter } from "@/components/Atoms/Box";
import Breadcrumb from "@/components/Atoms/Breadcrumb";
import Loader from "@/components/Atoms/Loader";
import MainTemplate from "@/components/Templates/MainTemplate";
import RecipeFilters from "@/components/Organisms/RecipeFilters";
import RecipesCarousel from "@/components/Organisms/RecipesCarousel";

import AppBanner from "@/containers/RecipeDetailPage/AppBanner";

import RecipeListContainer from "./RecipeContainer";

import { useWindowDimensions } from "@/hooks";
import useDisableIntercom from "@/hooks/useDisableIntercom";

import { useAppSelector } from "@/hooks";

import { mapRecipeListPageData } from "./mapRecipeListPageData";

import {
  PageContainer,
  PageSubtitle,
  PageTitle,
  LoaderContainer,
  BreadcrumbWrapper,
} from "./style";

// const RecipesCarousel = dynamic(
//   () => import("@/components/Organisms/RecipesCarousel"),
//   { ssr: false }
// );

interface RecipeListingPage {
  hasRecipeGroupedByParameter?: boolean;
  pageType?: string;
  recipeSlug?: string;
}
function RecipePage({
  hasRecipeGroupedByParameter = false,
  pageType,
  recipeSlug,
}: RecipeListingPage) {
  const { width } = useWindowDimensions();

  const heroBannerRef = useRef(null);
  const appBannerRef = useRef(null);
  const footerRef = useRef(null);

  const { error, data, isRecipeThreadLoading } = useAppSelector(
    (state) => state.recipe
  );

  useDisableIntercom({});

  const detectScroll = () => {
    window.onscroll = () => {
      const bannerPos =
        heroBannerRef?.current?.getBoundingClientRect()?.bottom || 0;
      const footerPos =
        footerRef?.current?.getBoundingClientRect()?.top - window.innerHeight;

      if (appBannerRef?.current) {
        if (footerPos >= 0 && bannerPos <= 0) {
          appBannerRef.current.style.opacity = "1";
          appBannerRef.current.style.visibility = "visible";
        } else {
          appBannerRef.current.style.opacity = "0";
          appBannerRef.current.style.visibility = "hidden";
        }
      }
    };
  };

  useEffect(() => {
    if (appBannerRef.current) detectScroll();
  });

  const { downloadBanner, topSection, recipeListData } = useMemo(
    () => mapRecipeListPageData(data, pageType, recipeSlug),
    [data, pageType, recipeSlug]
  );

  const Banner = (
    <AppBanner
      isStickyHeader
      title={downloadBanner?.appBanner?.title}
      appLinks={downloadBanner?.appBanner?.appCard?.appLinks}
      mobileLink={downloadBanner?.mobileLink}
      bannerRef={appBannerRef}
      width={width}
    />
  );

  const items = [
    {
      title: "Home",
      link: "/",
    },
    {
      title: "Recipes",
      link: "/recipes",
    },
    {
      title: recipeSlug,
    },
  ];

  return (
    <MainTemplate footerRef={footerRef}>
      <PageContainer width="100%" justifyContent="center">
        <div ref={heroBannerRef}>
          <PageTitle
            hasRecipeGroupedByParameter={hasRecipeGroupedByParameter}
            variant="heading1"
            fontFamily="var(--man-700)"
          >
            {topSection.title}
          </PageTitle>
        </div>
        {hasRecipeGroupedByParameter && (
          <PageSubtitle variant="heading2" fontFamily="var(--man-700)">
            {topSection.subTitle}
          </PageSubtitle>
        )}
        {pageType !== "HOME" && (
          <BreadcrumbWrapper>
            <Breadcrumb items={items} />
          </BreadcrumbWrapper>
        )}
        {pageType === "HOME" && <RecipeFilters />}
        <FlexCenter width="100%" bg="#f6fef9">
          {isRecipeThreadLoading ? (
            <LoaderContainer>
              <Loader />
            </LoaderContainer>
          ) : (
            <RecipeListContainer data={recipeListData} />
          )}
        </FlexCenter>
      </PageContainer>
      <RecipesCarousel />
      {Banner}
    </MainTemplate>
  );
}

export default RecipePage;
